export const maxLengthRule = (maxLength: number) => ({
	name: 'max-length',
	validate: (value: string) => value.length <= maxLength,
});
